import { all, takeLatest } from 'redux-saga/effects';
import { fetchKarmaEarnGame } from '../actions';
import fetchWorker from './worker.fetch';

function* karmaEarnSaga() {
  yield all([takeLatest(fetchKarmaEarnGame, fetchWorker)]);
}

export default karmaEarnSaga;
